import { TCompanyOnboardingPayload } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export type TValidateCompanyOnboardingShareableLinkTokenParams = {
  accessToken: string;
};

export const validateCompanyOnboardingShareableLinkToken = (
  axios: IAxiosInstance
) => {
  return async (
    body: TValidateCompanyOnboardingShareableLinkTokenParams
  ): Promise<TCompanyOnboardingPayload> => {
    const response = await axios.noRetry.post<{
      data: TCompanyOnboardingPayload;
    }>("/api/validateCompanyOnboardingShareableLinkToken", body);
    return response.data.data;
  };
};
